@if (activeLanguage) {
<button
  class="btn btn-light rounded-pill btn-lang"
  atxDropdown
  [atxDropdownMenu]="menu"
>
  <atx-flag-icon
    [countryCode]="languageIDToCountryCode(activeLanguage)"
  ></atx-flag-icon>
  <fa-icon [icon]="['fas', 'chevron-down']" size="xs"></fa-icon>
</button>
}
<atx-dropdown-menu #menu="atxDropdownMenu">
  @for (language of filteredLanguages(); track language) {
  <atx-dropdown-item
    [active]="isActive(language)"
    (click)="handleSelect(language.id)"
  >
    <atx-flag-icon
      class="mr-2"
      [countryCode]="languageIDToCountryCode(language.id)"
    ></atx-flag-icon>
    {{ language.name }}
  </atx-dropdown-item>
  }
</atx-dropdown-menu>
